export default __webpack_public_path__ + "static/media/about.c041600c.png";